import { get, isNil, omitBy, toString } from 'lodash/fp';

const omitNil = omitBy(isNil);

function decodeGame(game = {}) {
  const home = Array.isArray(game.teams) ? game.teams.find(t => t.is_home_team) : {};
  const away = Array.isArray(game.teams) ? game.teams.find(t => !t.is_home_team) : {};

  return omitNil({
    awayAbbr: game.away_team_abbreviation || game.away_team_name,
    awayId: away ? toString(away.id) : undefined,
    awayNickname: get('nick_name', away) || game.away_team_abbreviation || game.away_team_name,
    awayTeam: game.away_team_name,
    awayScore: game.away_team_score,
    countryCode: get('competition.competition_type.country.iso_alpha_2_code', game),
    distance: get('meta.distance', game),
    gameId: toString(game.id),
    gameOrder: get('gameOrder', game),
    homeAbbr: game.home_team_abbreviation || game.home_team_name,
    homeId: home ? toString(home.id) : undefined,
    homeNickname: get('nick_name', home) || game.home_team_abbreviation || game.home_team_name,
    homeTeam: game.home_team_name,
    homeScore: game.home_team_score,
    homeImage: home.image,
    awayImage: away.image,
    id: toString(game.id),
    isLocked: game.is_locked,
    label: get('label', game),
    name: game.name,
    number: get('meta.number', game),
    places: get('meta.number_of_places', game),
    progress: game.progress,
    startTime: game.start_time,
    statusId: get('status.id', game),
    track: get('meta.track_condition', game),
    venue: game.venue,
    weather: get('meta.weather', game)
  });
}

export default decodeGame;
